import * as THREE from 'three'
import Experience from './index'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export default class Camera {
  constructor() {
    this.experience = new Experience()
    this.sizes = this.experience.sizes
    this.time = this.experience.time
    this.scene = this.experience.scene
    this.canvas = this.experience.canvas

    this.createCameraInstance()
    this.createOrbitControls()
  }  

  createCameraInstance() {
    var vertical ;
    if(window.innerWidth < 575) {
      vertical = 40;
    } else {
      vertical = 35;
    }
    this.camera = new THREE.PerspectiveCamera(
      vertical,
      this.sizes.width / this.sizes.height,
      0.1,
      100
    )
    this.camera.position.set(0, 0, 5)
    this.scene.add(this.camera)
  }

  createOrbitControls() {
    this.orbitControls = new OrbitControls(this.camera, this.canvas)
    this.orbitControls.enabled = true
    this.orbitControls.enableDamping = true
    this.orbitControls.dampingFactor = 0.15
    this.orbitControls.enableZoom = false
    this.orbitControls.enablePan = false
    this.orbitControls.enableTilt = false
  }

  onResize() {
    this.camera.aspect = this.sizes.width / this.sizes.height
    this.camera.updateProjectionMatrix()
  }

  update() {
    this.orbitControls.update()
    this.orbitControls.autoRotateSpeed = 0.3
  }
}
